import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Layout, PageHeader } from "@/components/Layout";

export default function Audit() {
  const [tab, setTab] = useState("txns");
  const { data: txns = [] } = useQuery({
    queryKey: ["all-txns"],
    queryFn: async () => (await api.get("/admin/transactions")).data,
  });
  const { data: logs = [] } = useQuery({
    queryKey: ["audit-logs"],
    queryFn: async () => (await api.get("/admin/audit")).data,
  });

  return (
    <Layout>
      <PageHeader title="Auditoría" subtitle="Historial de transacciones y operaciones administrativas" />
      <div className="p-8">
        <div className="flex gap-2 mb-5">
          <button data-testid="audit-tab-txns" onClick={() => setTab("txns")}
            className={`px-4 py-1.5 rounded-md text-sm ${tab === "txns" ? "text-white" : "text-slate-400"}`}
            style={{ backgroundColor: tab === "txns" ? "#C2620E" : "#111827" }}>Transacciones de crédito</button>
          <button data-testid="audit-tab-admin" onClick={() => setTab("admin")}
            className={`px-4 py-1.5 rounded-md text-sm ${tab === "admin" ? "text-white" : "text-slate-400"}`}
            style={{ backgroundColor: tab === "admin" ? "#C2620E" : "#111827" }}>Operaciones admin</button>
        </div>

        {tab === "txns" ? (
          <div className="rounded-lg border overflow-hidden" style={{ borderColor: "#1E293B" }}>
            <table className="w-full text-sm" data-testid="txns-table">
              <thead style={{ backgroundColor: "#0D111A" }}>
                <tr className="text-left text-xs text-slate-500 uppercase">
                  <th className="px-4 py-3">Tipo</th><th className="px-4 py-3">Usuario</th>
                  <th className="px-4 py-3">Admin</th><th className="px-4 py-3">Monto</th>
                  <th className="px-4 py-3">Antes</th><th className="px-4 py-3">Después</th>
                  <th className="px-4 py-3">Job</th><th className="px-4 py-3">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {txns.map((t) => (
                  <tr key={t.id} className="border-t" style={{ borderColor: "#1E293B" }}>
                    <td className="px-4 py-2.5 font-mono text-xs text-red-400">{t.type}</td>
                    <td className="px-4 py-2.5 font-mono text-slate-300">{t.telegram_id}</td>
                    <td className="px-4 py-2.5 font-mono text-slate-500">{t.admin_telegram_id || "—"}</td>
                    <td className="px-4 py-2.5 font-mono text-amber-400">{t.amount}</td>
                    <td className="px-4 py-2.5 font-mono text-slate-400">{t.balance_before}</td>
                    <td className="px-4 py-2.5 font-mono text-slate-200">{t.balance_after}</td>
                    <td className="px-4 py-2.5 font-mono text-xs text-slate-500">{t.job_id || "—"}</td>
                    <td className="px-4 py-2.5 text-xs text-slate-500">{t.created_at?.slice(0, 19)}</td>
                  </tr>
                ))}
                {txns.length === 0 && <tr><td colSpan={8} className="px-4 py-8 text-center text-slate-500">Sin movimientos</td></tr>}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="rounded-lg border overflow-hidden" style={{ borderColor: "#1E293B" }}>
            <table className="w-full text-sm" data-testid="audit-table">
              <thead style={{ backgroundColor: "#0D111A" }}>
                <tr className="text-left text-xs text-slate-500 uppercase">
                  <th className="px-4 py-3">Admin</th><th className="px-4 py-3">Acción</th>
                  <th className="px-4 py-3">Objetivo</th><th className="px-4 py-3">Detalle</th>
                  <th className="px-4 py-3">Resultado</th><th className="px-4 py-3">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.id} className="border-t" style={{ borderColor: "#1E293B" }}>
                    <td className="px-4 py-2.5 font-mono text-slate-300">{l.admin_telegram_id}</td>
                    <td className="px-4 py-2.5 font-mono text-xs text-red-400">{l.action}</td>
                    <td className="px-4 py-2.5 font-mono text-slate-400">{l.target || "—"}</td>
                    <td className="px-4 py-2.5 text-slate-400">{l.detail || "—"}</td>
                    <td className="px-4 py-2.5 text-xs text-slate-500">{l.result || "—"}</td>
                    <td className="px-4 py-2.5 text-xs text-slate-500">{l.created_at?.slice(0, 19)}</td>
                  </tr>
                ))}
                {logs.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-500">Sin registros</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </Layout>
  );
}
